export default [
    {
        "id": "infographicBanner-1",
        "plugin": null,
        "pluginId": null,
        "name": null,
        "html": require('./infographicBanners/infographicBanner-1/html').default,
        "scss": require('./infographicBanners/infographicBanner-1/scss').default,
        "scssTablet": require('./infographicBanners/infographicBanner-1/scssTablet').default,
        "scssMobile": require('./infographicBanners/infographicBanner-1/scssMobile').default,
        "css": require('./infographicBanners/infographicBanner-1/css').default,
        "cssTablet": require('./infographicBanners/infographicBanner-1/cssTablet').default,
        "cssMobile": require('./infographicBanners/infographicBanner-1/cssMobile').default,
        "js": require('./infographicBanners/infographicBanner-1/js').default,
        "minJs": require('./infographicBanners/infographicBanner-1/minJs').default,
        "relatedBanner": "homepage-small",
        "svgContent": require('./infographicBanners/infographicBanner-1/svgContent').default,
        "svgViewBox": "0 0 1440 228",
        "svgContentMobile": require('./infographicBanners/infographicBanner-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 124"
    }
]